import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { UserProfilePictureComponent } from 'src/app/components/user-profile-picture/user-profile-picture.component';
import { NickyButtonComponent } from 'src/app/components/form/nicky-button/nicky-button.component';
import { PublicProfileStore } from 'src/app/stores/public-profile.store';
import { ModalsService } from 'src/app/services/modals.service';
import { TourService } from 'src/app/services/tour/tour.service';
import { ShareModalComponent } from 'src/app/components/modals/share-modal/share-modal.component';

@Component({
  selector: 'app-profile-header',
  imports: [
    CommonModule,
    TranslateModule,
    MatTooltipModule,
    MatIconModule,
    RouterModule,
    UserProfilePictureComponent,
    NickyButtonComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './profile-header.component.html',
})
export class ProfileHeaderComponent {
  protected publicProfileStore = inject(PublicProfileStore);
  protected modalService = inject(ModalsService);
  protected tourService = inject(TourService);

  handleConnectClick(): void {
    const profile = this.publicProfileStore.profileInfo();
    if (!profile?.email) return;

    if (this.publicProfileStore.alreadyFavorite()) {
      this.publicProfileStore.removeFavorite(profile.email);
    } else {
      this.publicProfileStore.addFavorite(profile.email);
    }
  }

  async openShareModal(): Promise<void> {
    await this.modalService.openModal(ShareModalComponent, {
      data: { profileInfo: this.publicProfileStore.profileInfo() },
    });
  }

  startTour(): void {
    this.tourService.startTour('PUBLIC_PROFILE');
  }
}
